// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__3BT4Y","title":"App_title__2C-7r"};